import { useState } from 'react';
// @mui
import { Stack, Typography, Divider, Box, Container, Grid, Card } from '@mui/material';
import { Helmet } from 'react-helmet-async';
// components
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import Alert from '@mui/material/Alert';
import axiosInstance from '../../utils/axiosInstance';
import SensorInfo from '../../components/sensor-info/sensorInfo';
import SingleSelector from '../../components/single-selector/singleSelector';

export default function NvStreamerConfiguration() {
  const { enqueueSnackbar } = useSnackbar();
  const [sensor, setSensor] = useState(null);
  const [sensorInfo, setSensorInfo] = useState(null);
  const [infoFetchStatus, setInfoFetchStatus] = useState('uninitialized');
  const sensorList = useSelector((state) => state.app.sensorList);

  const fetchSensorDetails = (sensor) => {
    if (!sensor) {
      return;
    }
    setInfoFetchStatus('pending');
    axiosInstance
      .get(`${window.location.protocol}//${sensor.host}/api/v1/sensor/${sensor.sensorId}/info`,{ headers: { "streamId": sensor.sensorId } })
      .then(async (response) => {
        setInfoFetchStatus('success');
        console.debug('fetchInfo response: ', response.data);
        setSensorInfo(response.data);
      })
      .catch((error) => {
        setInfoFetchStatus('error');
        if (error.response.data == null)
          enqueueSnackbar(`Error - ${error.response.status}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
        else
          enqueueSnackbar(`Error - ${error.response.data.error_message}`, {
            variant: 'error',
            anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
          });
      });
  };

  const handleSensorSelect = (cam) => {
    setSensor(cam);
    fetchSensorDetails(cam);
    if (!cam) {
      setSensorInfo(null);
    }
  };

  const sensorInfoPresent = sensor != null && sensorInfo != null;

  return (
    <>
      <Helmet>
        <title> Sensor details </title>
      </Helmet>

      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Configuration
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12}>
            <Card>
              <Box sx={{ p: 3 }}>
                <Stack spacing={3} sx={{ mb: 2 }}>
                  <SingleSelector
                    id="file-details"
                    placeholder="Type to search"
                    label="Select file"
                    value={sensor}
                    onChange={handleSensorSelect}
                    getOptionLabel={(option) => {
                      if (option.remoteDeviceName && option.remoteDeviceLocation) {
                        return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
                      } if (option.remoteDeviceName) {
                        return `${option.name} at ${option.remoteDeviceName}`;
                      }
                      return option.name;

                    }}
                    options={sensorList}
                  />
                  {sensor != null && sensorInfo != null && infoFetchStatus !== 'pending' && (
                    <Alert severity="success">{`file info found for ${sensor.name}`}</Alert>
                  )}
                  {sensor != null && sensorInfo == null && infoFetchStatus !== 'pending' && (
                    <Alert severity="error">{`Failed to get configuration for ${sensor.name}`}</Alert>
                  )}
                </Stack>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Card>
              <Box sx={{ p: 3 }}>
                <Stack spacing={3} sx={{ mb: 2 }}>
                  <Divider sx={{ my: 2 }}>
                    <Typography variant="h5" sx={{ color: 'text.secondary' }}>
                      File details
                    </Typography>
                  </Divider>
                  {sensorInfoPresent && (
                    <SensorInfo sensor={sensor} sensorInfo={sensorInfo} key={`${sensorInfo.sensorId}_info`} />
                  )}
                </Stack>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
